import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { errorColor } from './status/error';

export const error = (mode: PaletteMode, opts: GetThemeOptions): SimplePaletteColorOptions => {
  const color = errorColor(mode, opts);
  return {
    main: color.main,
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
